import type { AppTagProps } from '~/components/redesign/AppTag.vue';

export enum EventType {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export enum EventStatus {
  DRAFT = 'DRAFT',
  UPCOMING = 'UPCOMING',
  ONGOING = 'ONGOING',
  ON_DEMAND = 'ON_DEMAND',
  FINISHED = 'FINISHED',
}

export enum EventRegion {
  GLOBAL = 'Global',
  NORTH_AMERICA = 'North America',
  LATAM = 'LATAM',
  EMEA = 'EMEA',
}

export enum EventFormat {
  IN_PERSON = 'IN_PERSON',
  ONLINE = 'ONLINE',
  ON_DEMAND = 'ON_DEMAND',
  ONGOING = 'ONGOING',
}

export const EventTag: Record<
  EventFormat,
  {
    i18nKey: string;
    variant: AppTagProps['variant'];
  }
> = {
  [EventFormat.IN_PERSON]: {
    i18nKey: 'In_Person',
    variant: 'secondary',
  },
  [EventFormat.ONLINE]: {
    i18nKey: 'Online',
    variant: 'primary',
  },
  [EventFormat.ON_DEMAND]: {
    i18nKey: 'On_Demand',
    variant: 'tertiary',
  },
  [EventFormat.ONGOING]: {
    i18nKey: 'Ongoing',
    variant: 'quinary',
  },
};
